export default __webpack_public_path__ + "static/dca-a7d89bcbfde6c236cc2b84dae078e7d9.webp";